import { Plus } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { useState } from "react";
import { PlanForm } from "./PlanForm";

interface CreatePlanCardProps {
  onPlanCreated: () => void;
}

export const CreatePlanCard = ({ onPlanCreated }: CreatePlanCardProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Card className="hover:shadow-lg transition-shadow flex items-center justify-center min-h-[300px]">
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button variant="ghost" className="w-full h-full flex flex-col gap-4">
            <Plus className="h-12 w-12 text-primary" />
            <span className="text-lg font-semibold">Add New Plan</span>
          </Button>
        </DialogTrigger>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Create New Plan</DialogTitle>
          </DialogHeader>
          <PlanForm onSuccess={() => {
            setOpen(false);
            onPlanCreated();
          }} />
        </DialogContent>
      </Dialog>
    </Card>
  );
};